import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClausesService } from '@services/clauses.service';
import { RequirementService } from '@services/requirement.service';
import { SendingIdService } from '@services/sending-id.service';
import { TemplateService } from '@services/template.service';
import { UsersService } from '@services/users.service';
import { OFICIOS_TEMPLATE_IDS } from '../../../requirement/oficios-templates.constant';

export interface Options {
  multiple: boolean;
  width: string;
  tags: boolean;
}

@Component({
    selector: 'app-document-template',
    templateUrl: './document-template.component.html',
    styleUrls: ['./document-template.component.scss'],
    standalone: false
})
export class DocumentTemplateComponent implements OnInit {

  @Input() service: string;
  @Input() typeId: string;
  @Input() requirementId: string;
  @Output() insertTemplate = new EventEmitter<boolean>();

  modelSelect: number;
  clauses: any = [];
  customs: any = [];
  templates: Array<any>;
  public 
  documentForm: FormGroup;
  bloqk : boolean = true;
  generate : boolean = false;
  message : string = '';

  constructor(private activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private _clausesService: ClausesService,
    private _templateService: TemplateService,
    private fb: FormBuilder,
    ) {
      this.documentForm = this.fb.group({
        templateid: [null, Validators.required],
        itemcustoms: this.fb.array([]),
        itemclauses: this.fb.array([]),
        requirementid: [null, Validators.required],
    });
     }

  ngOnInit() {
    this.getTemplates();
  }

  isOficiosTemplate(templateId: number | string | null | undefined): boolean {
    return OFICIOS_TEMPLATE_IDS.has(Number(templateId));
  }

  getTemplates() {
    this._templateService.getTemplates(this.requirementId).subscribe(resp => {
      this.templates = resp['result'];
    })
  }

  getCustom($event) {
    this._templateService.getCustomTemplates($event,this.requirementId).subscribe(resp => {
      this.itemcustoms.clear()
      this.customs = resp['result'];
      this.cargaCustom(resp['result']);
      this.bloqk = false;
      if(resp['result'].length > 0){
        this.message = '';
      }
    })
  }

  getClauses($event) {
    this._clausesService.getClausesRequitement(this.requirementId,$event).subscribe(resp => {
      this.itemclauses.clear();
      this.clauses = resp['result'];
      this.cargaClauses(resp['result']);
      this.bloqk = false;
      if(resp['result'].length > 0){
        this.bloqk = false;
        this.message = '';
      }
    })
  }

  cargaCustom(data){
    data.forEach(item => {
      let gg = this.fb.group({
        id: item.id,
        name: item.name,
        value: item.value,
        fieldtype:item.fieldtype
      });
      this.itemcustoms.push(gg);
    });
  }

  cargaClauses(data){
    data.forEach(item => {
      let gg = this.fb.group({
        id: item.id,
        name: item.name,
        value: item.value
      });
      this.itemclauses.push(gg);
    });
  }

  onChange(formDirective: FormGroupDirective,$event){
    if($event){
      // Con bindValue="id", $event debería ser el ID directamente
      // Pero por si acaso, verificamos si es un objeto y extraemos el ID
      let templateId = $event;
      if (typeof $event === 'object' && $event !== null) {
        templateId = $event.id || $event;
      }
      // También podemos obtener el valor del formControl como respaldo
      const formValue = this.documentForm.get('templateid')?.value;
      if (formValue && !templateId) {
        templateId = formValue;
      }
      if (templateId) {
        this.getClauses(templateId);
        this.getCustom(templateId);
      }
    }
  }

  initData($event):void {
    this.getClauses($event);
    this.getCustom($event);
  }


  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  onCheckboxChange(e,index) {
    let item = this.findId(this.itemclauses.value, index);
    this.itemclauses.controls[item[0]].patchValue({
      id: item[1].id,
      name: item[1].name,
      value: e.target.checked
    });
  }

  get itemcustoms(): FormArray {
    return this.documentForm.get('itemcustoms') as FormArray;
  }
  get itemclauses(): FormArray {
    return this.documentForm.get('itemclauses') as FormArray;
  }

  findId = (array, id) => {
    let indice = array.findIndex(item => item.id === id);
    let found = array.find(a => a.id == id);
    return [indice,found];
  }

  clearFormArray = (formArray: FormArray) => {
    formArray = this.fb.array([]);
  }

  onSubmit(formDirective: FormGroupDirective){
    this.documentForm.patchValue({
      requirementid: this.requirementId
    });
    this.bloqk = true;
    this.generate = true;
    this.message = '';

    const templateId = Number(this.documentForm.value.templateid);
    const request$ = this.isOficiosTemplate(templateId)
      ? this._templateService.generateOficiosTemplate({
          requirementid: Number(this.requirementId),
          templateid: templateId,
          actionid: null
        })
      : this._templateService.createClause(this.documentForm.value);

    request$.subscribe({
      next: (resp) => {
        const result = resp?.['result'] || resp;
        const errorMessage =
          result?.error?.message ||
          (typeof result?.error === 'string' ? result.error : null) ||
          resp?.['error']?.message;
        if (errorMessage) {
          this.message = String(errorMessage).replace(/^ALERTA:\s*/i, '').trim();
          this.bloqk = false;
          this.generate = false;
          return;
        }
        if (result) {
          this.activeModal.dismiss();
          this.insertTemplate.emit(true);
          const url = result.url || result.value;
          const extra = result.extraDownloads as string[] | undefined;
          const downloadUrls = [url, ...(Array.isArray(extra) ? extra : [])].filter(
            (u): u is string => typeof u === 'string' && u.trim() !== ''
          );
          this.openDownloadUrls(downloadUrls);
        }
        this.bloqk = false;
        this.generate = false;
      },
      error: (error) => {
        const errorMessage =
          error?.error?.error?.message ||
          error?.error?.message ||
          error?.message ||
          'No se pudo generar el template';
        this.message = String(errorMessage).replace(/^ALERTA:\s*/i, '').trim();
        this.bloqk = false;
        this.generate = false;
      }
    });
  }

  /**
   * Pagaré PEN/USD u otros pares: el subscribe ya no está en el gesto del click;
   * abrimos el primero y pedimos confirmación para el resto (nuevo gesto → menos bloqueos).
   */
  private openDownloadUrls(urls: string[]): void {
    if (!urls.length) {
      return;
    }
    this.openDownloadUrl(urls[0]);
    if (urls.length === 1) {
      return;
    }
    const rest = urls.slice(1);
    const label =
      rest.length === 1
        ? 'Se generó un segundo documento (otra moneda). ¿Abrirlo ahora?'
        : `Hay ${rest.length} documentos adicionales. ¿Abrirlos ahora?`;
    if (window.confirm(label)) {
      rest.forEach((u) => this.openDownloadUrl(u));
    }
  }

  /** Descarga en pestaña nueva; fallback con <a> si el popup-blocker bloquea window.open. */
  private openDownloadUrl(url: string): void {
    const opened = window.open(url, '_blank', 'noopener,noreferrer');
    if (opened) {
      return;
    }
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }

}
